<script>
import Vue from 'vue'
const bus = new Vue()
export default bus
</script>




// WEBPACK FOOTER //
// src/BUS.vue